import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";
import * as TextVariables from "../../assets/Variables/TextVariables.js";
import Colors from "../../assets/Variables/ColorsVariables.js";
import DashboardBackground from "../Backgrounds/DashboardBackground.js";
import UserServices from "../../services/user.js";
import LoadingSpinner from "../Generals/Loaders/SpinLoader.js";
import * as styles from "./Styles.js";
import { Box, Link, Button, Popover, IconButton, Typography } from "@mui/material";
import LanguageSelector from "../Generals/Selectors/languageSelector.js";
import logo_communitraders from "../../assets/logos/Logo-communitraders.svg";
import NotificationModal from "../Generals/Notifications/NotificationModal.js";
import { useBreakpoint } from "../../config/BreakpointContext.js";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

const NavbarAndSidebar = (props) => {
  //#region "Instantiation of States"
  const { isXs, isMd } = useBreakpoint();
  const [avatarLetter, setAvatarLetter] = useState("");
  const [avatarColor, setAvatarColor] = useState("");
  const navigate = useNavigate();
  const [openProfileModal, setopenProfileModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [profileInfo, setProfileInfo] = useState({
    name: "",
    email: "",
  });
  const [modalProps, setModalProps] = useState({
    open: false,
    iconType: "",
    title: "",
    message: "",
    onAcceptLabel: undefined,
    onRefuseLabel: undefined,
    onContinueLabel: undefined,
    onAccept: undefined,
    onRefuse: undefined,
    onContinue: undefined,
  });
  const [openSidebar, setOpenSidebar] = useState(false);
  //#endregion

  //#region "Declaration of Normal Variables or Constants"

  const open = Boolean(null);
  const openProfile = Boolean(openProfileModal);
  const id = open ? "simple-popover" : undefined;

  //#endregion

  //#region "Handlers"
  const handleProfileClick = (event) => {
    setopenProfileModal(event.currentTarget);
  };

  const handleProfileClose = () => {
    setopenProfileModal(null);
  };

  const handleHome = () => {
    navigate("/admin/dashboard");
  };

  const handleLogout = () => {
    navigate("/admin/login");
  };

  const handleCloseNotification = (prevModalProps) => {
    setModalProps({ ...prevModalProps, open: false });
  };

  const handleOpenSideBar = () => {
    setOpenSidebar(!openSidebar);
  };

  //#endregion

  //#region "useEffects"
  useEffect(() => {
    if (profileInfo.name) {
      setAvatarLetter(profileInfo.name.split(" ")[0][0]);
      setAvatarColor(stringToColor(profileInfo.name));
    }
  }, [profileInfo.name]);
  useEffect(() => {
    RequestInformationData();
  }, []);
  //#endregion

  //#region "Requests"
  function stringToColor(string) {
    let hash = 0;
    let i;

    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
  }

  const getButtonColor = (menuItem) => {
    if (props.sidebarOption === menuItem) {
      return {
        backgroundColor: Colors.Secondary_50,
        color: "#15202A",
      };
    }
    return {};
  };

  const RequestInformationData = async () => {
    try {
      const response = await UserServices.getInformation();
      if (response.data != null) {
        setProfileInfo({
          name: response.data.data.name,
          login: response.data.data.account,
        });
      } else {
      }
    } catch (error) {
      setModalProps({
        open: true,
        iconType: "error",
        title: "Server error",
        message:
          "An error has occurred while loading the status information. Please try reloading, if the problem persists please contact an administrator",
        onAcceptLabel: "Continue",
        onAccept: () => handleCloseNotification(),
      });
    }
  };
  //#endregion

  //#region "HTML"
  return (
    <>
      <Box sx={{ height: "100%", margin: "0", padding: "0" }}>
        {loading ? <LoadingSpinner /> : <></>}
        <DashboardBackground></DashboardBackground>
        <NotificationModal
          open={modalProps.open}
          onClose={handleCloseNotification}
          iconType={modalProps.iconType}
          title={modalProps.title}
          message={modalProps.message}
          onAcceptLabel={modalProps.onAcceptLabel}
          onAccept={modalProps.onAccept}
          onRefuseLabel={modalProps.onRefuseLabel}
          onRefuse={modalProps.onRefuse}
          onContinueLabel={modalProps.onContinueLabel}
          onContinue={modalProps.onContinue}
        />
        <Box sx={styles.navbar}>
          <IconButton
            sx={{
              backgroundColor: "transparent",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
            onClick={(e) => handleHome()}
          >
            <img src={logo_communitraders} alt="Tradeview" width={"200"} />
          </IconButton>
          {isMd && (
            <Box sx={styles.perfilContainer}>
              <LanguageSelector></LanguageSelector>
              <Button sx={styles.profileBox} onClick={handleProfileClick}>
                <Avatar
                  sx={{
                    alt: "user icon",
                    bgcolor: avatarColor,
                    width: 20,
                    height: 20,
                    fontSize: 15,
                    padding: 2,
                  }}
                >
                  {avatarLetter}
                </Avatar>
                <Box sx={styles.nameBox}>
                  <Typography
                    sx={{
                      fontFamily: TextVariables.Caption_1,
                      lineHeight: "1",
                    }}
                  >
                    Hello
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: TextVariables.Body_3_Bold,
                      lineHeight: "1",
                    }}
                  >
                    {profileInfo.name.split(" ")[0]}
                  </Typography>
                </Box>
                <span className="material-symbols-outlined">expand_more</span>
              </Button>
              <Popover
                id={id}
                open={openProfile}
                anchorEl={openProfileModal}
                onClose={handleProfileClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                PaperProps={{
                  sx: {
                    maxHeight: "416px", // Altura máxima del popover para evitar expandir demasiado
                    overflowY: "hidden", // Habilita el scroll si el contenido es grande
                  },
                }}
              >
                <Box sx={styles.modalProfile}>
                  <Box sx={styles.modalProfileTitle}>
                    <Avatar
                      sx={{
                        alt: "user icon",
                        bgcolor: avatarColor,
                        width: 20,
                        height: 20,
                        fontSize: 15,
                        padding: 2,
                      }}
                    >
                      {avatarLetter}
                    </Avatar>
                    <Box sx={styles.nameBox}>
                      <Typography
                        sx={{
                          fontFamily: TextVariables.Body_3_Bold,

                          lineHeight: "1",
                        }}
                      >
                        {profileInfo.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: TextVariables.Caption_1,
                          lineHeight: "1",
                        }}
                      >
                        {profileInfo.login}
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Button sx={styles.profileSelector} onClick={handleLogout}>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: Colors.Secondary_900 }}
                      >
                        logout
                      </span>
                      <Typography
                        sx={{
                          fontFamily: TextVariables.Caption_1,
                          width: "100%",
                        }}
                      >
                        Log Out
                      </Typography>
                    </Button>
                  </Box>
                </Box>
              </Popover>
            </Box>
          )}
          {isXs && (
            <IconButton onClick={handleOpenSideBar}>
              <MenuIcon />
            </IconButton>
          )}
        </Box>
        {isMd && (
          <Box sx={styles.sideBar}>
            <Box sx={styles.infoSidebar}>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: TextVariables.Body_4_Bold,
                  lineHeight: 1,
                }}
              >
                Administrator
              </Typography>
              <Box sx={styles.sidebarNameContainer}>
                <Typography
                  sx={{
                    fontFamily: TextVariables.Caption_1,
                    color: "rgba(255, 255, 255, 0.8)",
                    lineHeight: 1,
                  }}
                >
                  {profileInfo.name}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: TextVariables.Caption_1,
                    color: "rgba(255, 255, 255, 0.8)",
                    lineHeight: 1,
                  }}
                >
                  {profileInfo.login}
                </Typography>
              </Box>
            </Box>
            <Box sx={styles.nav}>
              <Link
                sx={styles.tab}
                style={getButtonColor("Dashboard")}
                component={RouterLink}
                to="/admin/dashboard"
              >
                <span className="material-symbols-outlined" style={{ fontSize: "20px" }}> dashboard </span>
                Dashboard
              </Link>
              <Link
                sx={styles.tab}
                style={getButtonColor("Accounts")}
                component={RouterLink}
                to="/admin/accounts"
              >
                <span className="material-symbols-outlined" style={{ fontSize: "20px" }} > group </span>
                Accounts
              </Link>
              <Link
                sx={styles.tab}
                style={getButtonColor("Copies")}
                component={RouterLink}
                to="/admin/trading"
              >
                <span className="material-symbols-outlined" style={{ fontSize: "20px" }} > folder_match </span>
                Copies
              </Link>
              <Link
                sx={styles.tab}
                style={getButtonColor("Supports")}
                component={RouterLink}
                to="/admin/supports"
              >
                <span className="material-symbols-outlined" style={{ fontSize: "20px" }} > support_agent </span>
                Supports
              </Link>
              <Link
                sx={styles.tab}
                style={getButtonColor("Statements")}
                component={RouterLink}
                to="/admin/statements"
              >
                <span className="material-symbols-outlined" style={{ fontSize: "20px" }} > document_scanner </span>
                Statements
              </Link>
              <Link
                sx={styles.tab}
                style={getButtonColor("Logs History")}
                component={RouterLink}
                to="/admin/logs"
              >
                <span className="material-symbols-outlined" style={{ fontSize: "20px" }} > assignment </span>
                Logs History
              </Link>            
            </Box>
          </Box>
        )}
        {isXs && openSidebar && (
          <Box sx={styles.smallSidebarContainer}>
            <Box sx={styles.EmptySidebar}></Box>
            <Box sx={styles.sideBarSmall}>
              <IconButton
                sx={styles.closeIconContainer}
                onClick={handleOpenSideBar}
              >
                <CloseIcon sx={{ color: "white" }} />
              </IconButton>
              <Box sx={styles.infoSidebarSmall}>
                <Box sx={styles.profileBoxSmall}>
                  <Avatar
                    sx={{
                      alt: "user icon",
                      bgcolor: avatarColor,
                      width: 20,
                      height: 20,
                      fontSize: 15,
                      padding: 2,
                    }}
                  >
                    {avatarLetter}
                  </Avatar>
                  <Box sx={styles.nameBox}>
                    <Typography
                      sx={{
                        fontFamily: TextVariables.Caption_1,
                        lineHeight: "1",
                        color: "white",
                      }}
                    >
                      Hello {profileInfo.name.split(" ")[0]}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: TextVariables.Body_3_Bold,
                        lineHeight: "normal",
                        color: "white",
                        whiteSpace: "nowrap", 
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "150px",  
                        display: "block", 
                      }}
                    >
                      {profileInfo.login}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box sx={styles.infoSidebarSmall}>
                <Typography
                  sx={{
                    width: "100%",
                    fontFamily: TextVariables.Body_4_Bold,
                    lineHeight: 1,
                  }}
                >
                  Administrator
                </Typography>
                <Box sx={styles.sidebarNameContainer}>
                  <Typography
                    sx={{
                      fontFamily: TextVariables.Caption_1,
                      color: "rgba(255, 255, 255, 0.8)",
                      lineHeight: 1,
                    }}
                  >
                    {profileInfo.name}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: TextVariables.Caption_1,
                      color: "rgba(255, 255, 255, 0.8)",
                      lineHeight: 1,
                    }}
                  >
                    {profileInfo.login}
                  </Typography>
                </Box>
              </Box>

              <Box sx={styles.nav}>
                <Link
                  sx={styles.tab}
                  style={getButtonColor("Dashboard")}
                  component={RouterLink}
                  to="/admin/dashboard"
                >
                  <span className="material-symbols-outlined" style={{ fontSize: "20px" }}> dashboard </span>
                  Dashboard
                </Link>
                <Link
                  sx={styles.tab}
                  style={getButtonColor("Accounts")}
                  component={RouterLink}
                  to="/admin/accounts"
                >
                  <span className="material-symbols-outlined" style={{ fontSize: "20px" }} > group </span>
                  Accounts
                </Link>
                <Link
                  sx={styles.tab}
                  style={getButtonColor("Copies")}
                  component={RouterLink}
                  to="/admin/trading"
                >
                  <span className="material-symbols-outlined" style={{ fontSize: "20px" }} > folder_match </span>
                  Copies
                </Link>
                <Link
                  sx={styles.tab}
                  style={getButtonColor("Supports")}
                  component={RouterLink}
                  to="/admin/supports"
                >
                  <span className="material-symbols-outlined" style={{ fontSize: "20px" }} > support_agent </span>
                  Supports
                </Link>
                <Link
                  sx={styles.tab}
                  style={getButtonColor("Statements")}
                  component={RouterLink}
                  to="/admin/statements"
                >
                  <span className="material-symbols-outlined" style={{ fontSize: "20px" }} > document_scanner </span>
                  Statements
                </Link>
                <Link
                  sx={styles.tab}
                  style={getButtonColor("Logs History")}
                  component={RouterLink}
                  to="/admin/logs"
                >
                  <span className="material-symbols-outlined" style={{ fontSize: "20px" }} > assignment </span>
                  Logs History
                </Link>
              </Box>
              <Box sx={styles.nav}>
                <Link sx={styles.tab} onClick={handleLogout}>
                  <span
                    className="material-symbols-outlined"
                    style={{ fontSize: "20px" }}
                  >
                    logout
                  </span>
                  Log out
                </Link>
              </Box>
            </Box>
          </Box>
        )}

        <Box sx={isMd === true ? styles.content : styles.contentSmall}>
          {props.children}
        </Box>
      </Box>
    </>
  );
  //#endregion
};

export default NavbarAndSidebar;
